import { Box, BoxProps, Text } from "@chakra-ui/react";
import { Note, NoteType } from "common";
import moment from "moment";
import { NoteCreateTeamBody } from "./NoteCreateTeamBody";
import { NoteTeamPointBody } from "./NoteTeamPointBody";
import { FaClock } from "react-icons/fa";
import { NoteCreateYouthKidBody } from "./NoteCreateYouthKidBody";
import { NoteUpdateYouthKidBody } from "./NoteUpdateYouthKidBody";
import { NoteUpdateTeamBody } from "./NoteUpdateTeamBody";
import { NoteDeleteYouthKidBody } from "./NoteDeleteYouthKidBody";
import { NoteDeleteTeamBody } from "./NoteDeleteTeamBody";
import { Card } from "../utils/Card";

interface NoteCardProps extends BoxProps {
  note: Note;
}

export const NoteCard = ({ note, ...props }: NoteCardProps) => {
  return (
    <Card padding={4} {...props}>
      {note.type === NoteType.TeamPoint ? (
        <NoteTeamPointBody note={note} />
      ) : note.type === NoteType.CreateTeam ? (
        <NoteCreateTeamBody note={note} />
      ) : note.type === NoteType.CreateYouthKid ? (
        <NoteCreateYouthKidBody note={note} />
      ) : note.type === NoteType.UpdateYouthKid ? (
        <NoteUpdateYouthKidBody note={note} />
      ) : note.type === NoteType.UpdateTeam ? (
        <NoteUpdateTeamBody note={note} />
      ) : note.type === NoteType.DeleteYouthKid ? (
        <NoteDeleteYouthKidBody note={note} />
      ) : note.type === NoteType.DeleteTeam ? (
        <NoteDeleteTeamBody note={note} />
      ) : null}
      <Box marginTop={2} display={"flex"} alignItems={"center"}>
        <FaClock />
        <Text marginLeft={1}>
          {moment.unix(note.createTime / 1000).fromNow()}
        </Text>
      </Box>
    </Card>
  );
};
